import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import { FaEye } from 'react-icons/fa';
import { replaceDotForComma } from '../../utils/Regex';
import { cpfMask, formatDocument } from '../../utils/functions';
import { Box } from '@mui/material';

const StyledTableCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'customStyle'
})(({ customStyle }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...customStyle,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme, color }) => ({
  backgroundColor: color ? color : 'white',
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createNewData(column, value, trueMessage, falseMessage) {
  
  let finalParent = value
  if (column?.value?.first?.parent) {
    let parent = column?.value?.first?.parent
    if (parent?.length > 0) {
      for (let i = 0; i < parent?.length; i++) {
        finalParent = finalParent?.[`${parent[i]}`]
        if (finalParent?.length > 0) {
          finalParent = finalParent[0]
        }
      }
      if (finalParent?.[`${column.value.first.value}`]) return formatValue(column.type, finalParent?.[`${column.value.first.value}`], column.trueMessage, column.falseMessage)
    }
  }
  
  if (value?.[`${column.value.first.value}`]) return formatValue(column.type, value?.[`${column.value.first.value}`], column.trueMessage, column.falseMessage)
  
  if (column?.value?.second) {
    let parent = column?.value?.second?.parent
    let finalParent = value
    if (parent?.length > 0) {
      for (let i = 0; i < parent?.length; i++) {
        finalParent = finalParent?.[`${parent[i]}`]
        if (finalParent.length > 0) {
          finalParent = finalParent[0]
        }
      }
    }
    if (finalParent?.[`${column.value.second.value}`]) return formatValue(column.type, finalParent?.[`${column.value.second.value}`], column.trueMessage, column.falseMessage)
  }
  if (value?.[`${column?.value?.second?.value}`]) return formatValue(column.type, value?.[`${column?.value?.second?.value}`], column.trueMessage, column.falseMessage)

  if (column.type === 'bool') {
    return value?.[`${column.value.first.value}`] ? column.trueMessage : column.falseMessage;
  }

  if(column.noData) return column.noData
  
  return 'Não informado';
}

function returnColumn(column) {
  return column.headerName
}

function translateDuration(value) {
  const translations = {
    months: "meses",
    days: "dias",
    years: "anos",
  };

  return translations[value] || "Tradução não disponível";
}

function formatValue(type, value, trueMessage, falseMessage) {
  if (type === 'money') {
    return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value);
  }
  if (type === 'date') {
    return moment.utc(value).format('DD/MM/YYYY');
  }

  if (type === 'timedate') {
    return value ? moment.utc(value).format('DD/MM/YYYY - HH:mm') : 'No Data';
  }
  if (type === 'percent') {
    return value ? value.toString().match(/./) != null ? `${replaceDotForComma(value.toString())} %` : `${value} %` : "Não informado";
  }

  if (type === 'CPF') {
    return value ? cpfMask(value) : 'No Data';
  }

  if (type === 'DOCUMENT') {
    return value ? formatDocument(value) : 'No Data';
  }

  if (type === "duration_unit") {
    return value ? translateDuration(value) : "No Data";
  }

  if (type === 'bool') {
    return value ? trueMessage : falseMessage;
  }

  return value
}

export default function CustomizedTables({ dataColorChange, data, columns, options, action, moreOptionsTitle, moreOptions, columnStyle, moreActions }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {options && <StyledTableCell align="left" >Ações</StyledTableCell>}
            {columns.map((column) => (
              <StyledTableCell key={column.field} align="left">{returnColumn(column)}</StyledTableCell>
            ))}
            {moreOptionsTitle && 
              <StyledTableCell align="left">{moreOptionsTitle}</StyledTableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <StyledTableRow key={index}
              color={dataColorChange ? dataColorChange(row) : ''}
            >
              {options &&
                <StyledTableCell align="center" customStyle={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: '#1F7DB6',
                      height: '32px',
                      fontSize: '20px',
                      cursor: 'pointer',
                    }} lg={3} md={4} xs={12} onClick={() => action(row)}>
                      <FaEye />
                    </Box>
                    {moreActions && moreActions(row)}
                </StyledTableCell>
              }
              {columns.map((column, index) => 
                <StyledTableCell key={index} align="left" customStyle={columnStyle ? columnStyle(column, row) : {}}>{createNewData(column, row)}</StyledTableCell>
              )}
              {moreOptions &&
                <StyledTableCell align="left">{moreOptions(row)}</StyledTableCell>
              }
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}